import React from "react";

interface OrganizationExistsModalProps {
  isOpen: boolean;
  email: string;
  onClose: () => void;
  onUseDifferentEmail: () => void;
  onResetForm: () => void;
}

export const OrganizationExistsModal: React.FC<
  OrganizationExistsModalProps
> = ({ isOpen, email, onClose, onUseDifferentEmail, onResetForm }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg
              className="h-6 w-6 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
              />
            </svg>
          </div>

          <h3 className="text-lg font-medium text-gray-900 mb-2">
            Email Already in Use
          </h3>

          <p className="text-sm text-gray-500 mb-6">
            The email <strong>{email}</strong> is already associated with
            another organization and cannot be used for a new profile.
          </p>

          <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-left mb-6">
            <h4 className="font-medium text-red-800 text-sm mb-1">
              Why This Happens
            </h4>
            <p className="text-xs text-red-700">
              Each email address can only be associated with one organization
              profile. This email is already being used by another organization.
            </p>
          </div>

          <div className="flex space-x-3">
            <button
              onClick={onClose}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Close
            </button>
            <button
              onClick={onResetForm}
              className="flex-1 px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Reset Form
            </button>
            <button
              onClick={onUseDifferentEmail}
              className="flex-1 px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
            >
              Use Different Email
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
